'use client';

import React, { useMemo, type ComponentProps } from 'react';
import styled from 'styled-components';
import { useToken } from './state';

type ReactImage = ComponentProps<'img'>;
type ReactAnchor = ComponentProps<'a'>;

export interface LogoProps extends ReactAnchor {
  mobile?: ReactImage;
  desktop?: ReactImage;
}

function Logo({
  mobile = {
    alt: 'Storebrand',
    src: 'https://assets-t.storebrand.no/logos/beta/storebrand-logo-only.svg',
  },
  desktop = {
    alt: 'Storebrand',
    src: 'https://assets-t.storebrand.no/logos/beta/storebrand-logo-desktop.svg',
  },
  ...props
}: LogoProps) {
  const { token } = useToken();

  const href = useMemo(() => {
    if (props.href) {
      return props.href;
    }

    return token ? '/oversikt' : '/';
  }, [props.href, token]);

  return (
    <LogoBase
      {...props}
      href={href}
      data-trackid="link-navbar_logo|Storebrand logo"
    >
      <LogoDesktop {...desktop} />
      <LogoMobile {...mobile} />
    </LogoBase>
  );
}

export const LogoDesktop = styled.img``;
export const LogoMobile = styled.img``;

export const LogoBase = styled.a`
  grid-area: logo;

  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 100%;

  &:focus-visible {
    outline-offset: -8px;
    outline: 2px solid var(--navbar-toggle-background, #700);
  }

  & > ${LogoDesktop} {
    display: block;

    box-sizing: border-box;

    width: 196px;
    height: auto;

    padding: 0 16px;
  }

  & > ${LogoMobile} {
    display: none;

    box-sizing: border-box;

    width: 64px;
    height: auto;

    padding: 0 16px;
  }

  @media (max-width: 768px) {
    & > ${LogoDesktop} {
      display: none;
    }

    & > ${LogoMobile} {
      display: block;
    }
  }
`;

export default Logo;
